/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formmessage_Textlimit2Inputs */

const ja_contact_formmessage_textlimit2 = /** @type {(inputs: Contact_Formmessage_Textlimit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500文字以内で記入してください。`)
};

const en_contact_formmessage_textlimit2 = /** @type {(inputs: Contact_Formmessage_Textlimit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max 500 words.`)
};

/**
* | output |
* | --- |
* | "Max 500 words." |
*
* @param {Contact_Formmessage_Textlimit2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formmessage_textlimit2 = /** @type {((inputs?: Contact_Formmessage_Textlimit2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formmessage_Textlimit2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formmessage_textlimit2(inputs)
	return en_contact_formmessage_textlimit2(inputs)
});
export { contact_formmessage_textlimit2 as "contact_formMessage_textLimit" }